import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'

import { T, useTranslate } from 'lib/tolgee'

const TOLGEE_PREFIX = 'GenerateWinninAIReportUseCaseModal'

function BrandAnalysisContent({ setFormValues, formValues }) {
  const t = useTranslate()
  const totalCharacters = formValues?.brandDescription?.length || 0
  return (
    <>
      <div>
        <p className="TerritoryAnalysisContent-description">
          <T keyName={`${TOLGEE_PREFIX}-territoryAnalysisDescription`}>
            Precisamos de algumas informações para que nossa AI consiga fazer um bom trabalho e entregue algo
            personalizado para sua marca!
          </T>
        </p>
      </div>

      <InputWithLabel
        label={t({
          key: `${TOLGEE_PREFIX}-brand`,
          defaultValue: 'Nome da marca',
        })}
        name="brand"
        placeholder={t({
          key: `${TOLGEE_PREFIX}-brandPlaceholder`,
          defaultValue: 'Para qual marca você gostaria de gerar o report?',
        })}
        onChange={e => {
          setFormValues(prevState => ({ ...prevState, [e.target.name]: e.target.value }))
        }}
      />
      <div className="TerritoryAnalysisContent-brandDescription">
        <InputWithLabel
          label={t({
            key: `${TOLGEE_PREFIX}-brandDescription`,
            defaultValue: 'Breve descrição sobre a marca',
          })}
          name="brandDescription"
          placeholder={t({
            key: `${TOLGEE_PREFIX}-brandDescriptionPlaceholder`,
            defaultValue: 'Ex: Marca brasileira de laticíneos veganos nova no mercado',
          })}
          onChange={e => {
            setFormValues(prevState => ({ ...prevState, [e.target.name]: e.target.value }))
          }}
          maxLength={150}
        />
        <span>
          <T keyName={`${TOLGEE_PREFIX}-characters`} parameters={{ totalCharacters }}>
            {'{totalCharacters}/150 caracteres'}
          </T>
        </span>
      </div>
    </>
  )
}

export default BrandAnalysisContent
